import { useRef, useCallback } from 'react';

// Snapshot a form's values when a modal opens (markClean), then use
// confirmClose() instead of closing directly. If the form has changed
// since the snapshot, the user is asked to confirm before discarding.
export default function useUnsavedChanges() {
  const initialRef = useRef(null);

  const markClean = useCallback((state) => {
    initialRef.current = JSON.stringify(state);
  }, []);

  const confirmClose = useCallback((state, closeFn) => {
    const isDirty = initialRef.current !== null && JSON.stringify(state) !== initialRef.current;
    if (isDirty && !window.confirm('You have unsaved changes. Discard them?')) {
      return;
    }
    initialRef.current = null;
    closeFn();
  }, []);

  return { markClean, confirmClose };
}
